import React from 'react';
import CrudPage from '../../components/CrudPage';
import { pruApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'pruId' },
  { header: 'Name', field: 'name' },
  { header: 'Value', field: 'value' },
  { header: 'Description', field: 'description' },
];

const formFields = [
  { name: 'name', label: 'Name', type: 'text', required: true },
  { name: 'value', label: 'Value', type: 'text', required: true },
  { name: 'description', label: 'Description', type: 'textarea' },
];

const PruPage = () => (
  <CrudPage
    title="PRU"
    subtitle="Manage PRU settings"
    api={pruApi}
    columns={columns}
    formFields={formFields}
    idField="pruId"
    searchField="name"
  />
);

export default PruPage;
